import type { SearchEvent, SearchSet } from '@shared/searchIndex'
import { EventResultRow, ResultButton } from '../../components/GlobalSearch/SearchResultRows'
import { formatDayShort } from '../../lib/formatDate'
import type { ArtistEventAppearance } from '../../hooks/useArtistAppearances'
import { useTimeFormat } from '../../hooks/useTimeFormat'

function setMeta(set: SearchSet, locale: string, formatClock: (hhmm: string) => string): string {
  const day = formatDayShort(set.day, locale)
  const when = set.startTime ? `${day} ${formatClock(set.startTime)}` : day
  return [when, set.stageName, set.title].filter(Boolean).join(' · ')
}

/** Each event the artist plays, with their sets indented under it. */
export function ArtistAppearanceList({
  appearances, past, isAway, locale, onSelectEvent, onSelectSet,
}: {
  appearances: ArtistEventAppearance[]
  past: boolean
  isAway: (event: SearchEvent) => boolean
  locale: string
  onSelectEvent: (event: SearchEvent) => void
  onSelectSet: (event: SearchEvent, set: SearchSet) => void
}) {
  const { formatClock } = useTimeFormat()
  return (
    <div>
      {appearances.map(({ event, sets }) => (
        <div key={event.id} className="py-1">
          {/* The section heading already says "Past", so the row's badge would repeat it. */}
          <EventResultRow
            event={event}
            away={!past && isAway(event)}
            locale={locale}
            onSelect={() => onSelectEvent(event)}
          />
          {sets.map(set => (
            <ResultButton
              key={set.id}
              onClick={() => onSelectSet(event, set)}
              className="py-1.5 pl-[3.75rem] text-muted-foreground"
            >
              <span className="min-w-0 flex-1 truncate">{setMeta(set, locale, formatClock)}</span>
            </ResultButton>
          ))}
        </div>
      ))}
    </div>
  )
}
